export default {
  en: {
    title: 'Working hours',
    subtitle: 'Define the working hours by team or service',
    form: {
      label: {
        label: 'Name',
        hint: 'Set a name to identify easily',
        placeholder: 'Internal name'
      },
      notificationEnabled: {
        label: 'Notification enabled',
        hint: 'Activate or disable notification of connections based on the working hours',
      },
      gracePeriod: {
        label: 'Grace period',
        hint: 'Minutes of grace period to connect based on the start hour for each day',
        placeholder: 'Minutes'
      },
      daysAndHours: {
        label: 'Days of the week',
        hint: 'Define the ranges by day of the week to control the agents connection',
        empty: 'Day of the week not monitored',
      },
      subscribers: {
        label: 'Subscribers',
        hint: 'Select the subscribers will receive the notification with the connection summary each day',
        placeholder: 'Select the subscribers',
      },
      agents: {
        label: 'Agents',
        hint: 'Agents to be monitored',
        placeholder: 'Select agents to monitor',
      }
    }
  },
  es: {
    title: 'Horarios laborales',
    subtitle: 'Establecer horarios laborales por equipo o servicio',
    form: {
      label: {
        label: 'Nombre',
        hint: 'Establece un nombre para identificar fácilmente',
        placeholder: 'Nombre interno'
      },
      notificationEnabled: {
        label: 'Notificaciones activas',
        hint: 'Activar o desactivar las notificaciones de conexión según el horario laboral',
      },
      gracePeriod: {
        label: 'Período de gracia',
        hint: 'Minutos de tolerancia permitidos para la conexión después de la hora de inicio de cada día',
        placeholder: 'Minutos'
      },
      daysAndHours: {
        label: 'Días de la semana',
        hint: 'Definir los rangos horarios por día para controlar la conexión de los agentes',
        empty: 'Día no supervisado',
      },
      subscribers: {
        label: 'Suscriptores',
        hint: 'Seleccionar los suscriptores que recibirán el resumen diario de conexiones',
        placeholder: 'Seleccionar suscriptores',
      },
      agents: {
        label: 'Agentes',
        hint: 'Agentes a supervisar',
        placeholder: 'Seleccionar agentes a supervisar',
      }
    }
  },
  fr: {
    title: 'Heures les travaux',
    subtitle: 'Définir les horaires de travail par équipe ou service',
    form: {
      label: {
        label: 'Nom',
        hint: 'Définir un nom pour identifier facilement',
        placeholder: 'Nom interne'
      },
      notificationEnabled: {
        label: 'Notifications activées',
        hint: 'Activer ou désactiver les notifications de connexion selon les heures les travaux',
      },
      gracePeriod: {
        label: 'Délai de grâce',
        hint: 'Minutes de tolérance autorisées pour la connexion après l\'heure de début de chaque journée',
        placeholder: 'Minutes'
      },
      daysAndHours: {
        label: 'Jours de la semaine',
        hint: 'Définir les plages horaires par jour pour contrôler la connexion des agents',
        empty: 'Jour non surveillé',
      },
      subscribers: {
        label: 'Destinataires',
        hint: 'Sélectionner les destinataires qui recevront le récapitulatif quotidien des connexions',
        placeholder: 'Sélectionner les destinataires',
      },
      agents: {
        label: 'Agents',
        hint: 'Agents à surveiller',
        placeholder: 'Sélectionner les agents à surveiller',
      }
    }
  },
}
